import React, { useEffect, useRef } from 'react';
import './GoogleMapsPreview.css';

function GoogleMapsPreview({ query, location, visible }) {
  const popupWindowRef = useRef(null);

  // Build Google Maps search URL
  const searchQuery = `${encodeURIComponent(query)}+${encodeURIComponent(location)}`;
  const directMapsUrl = `https://www.google.com/maps/search/${searchQuery}`;

  // Open popup window when scraping starts
  useEffect(() => {
    if (!visible || !query || !location) {
      // Close any existing popup when preview is hidden or inputs reset
      if (popupWindowRef.current && !popupWindowRef.current.closed) {
        popupWindowRef.current.close();
      }
      popupWindowRef.current = null;
      return;
    }

    // Open Google Maps popup only once per scrape session
    if (!popupWindowRef.current || popupWindowRef.current.closed) {
      const width = 1200;
      const height = 800;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;
      
      popupWindowRef.current = window.open(
        directMapsUrl,
        'GoogleMapsPreview',
        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
      );
    }
  }, [visible, query, location, directMapsUrl]);

  if (!visible || !query || !location) {
    return null;
  }

  return (
    <div className="maps-preview-container">
      <div className="maps-preview-header">
        <h3>Google Maps Preview</h3>
        <p>Viewing search results for: <strong>{query}</strong> in <strong>{location}</strong></p>
        <div className="maps-preview-actions">
          <a 
            href={directMapsUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="open-maps-link"
            onClick={() => {
              if (popupWindowRef.current) {
                popupWindowRef.current.focus();
              }
            }}
          >
            {popupWindowRef.current && !popupWindowRef.current.closed 
              ? 'Focus Popup Window →' 
              : 'Open in New Tab →'}
          </a>
          {popupWindowRef.current && !popupWindowRef.current.closed && (
            <span className="popup-status">✓ Popup window is open</span>
          )}
        </div>
      </div>
      <div className="maps-preview-wrapper">
        <div className="maps-fallback">
          <div className="maps-info-icon">🗺️</div>
          <p><strong>Google Maps is open in a popup window</strong></p>
          <p>Google Maps cannot be embedded in an iframe for security reasons.</p>
          <p>The popup window shows the search results being scraped.</p>
          <a 
            href={directMapsUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="fallback-button"
            onClick={() => {
              if (popupWindowRef.current) {
                popupWindowRef.current.focus();
              }
            }}
          >
            {popupWindowRef.current && !popupWindowRef.current.closed 
              ? 'Focus Popup Window' 
              : 'Open Google Maps'}
          </a>
        </div>
      </div>
    </div>
  );
}

export default GoogleMapsPreview;

